import { Box } from '../../../../Box/Box';
import { Button } from '../../../../Button/Button';

type TryAgainButtonProps = {
  fileName: string;
  onTryAgainClick: () => void;
};

export function TryAgainButton({
  fileName,
  onTryAgainClick,
}: TryAgainButtonProps) {
  return (
    <Box
      as={Button}
      aria-label={`Повторить загрузку ${fileName}`}
      vertSize="40"
      type="button"
      kind="borderless"
      alignSelf="flex-start"
      onClick={onTryAgainClick}
    >
      Повторить загрузку
    </Box>
  );
}
